"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BANNER_BUNDLE_FILE_NAME = exports.BANNER_COMPONENT_ID = void 0;
exports.BANNER_COMPONENT_ID = 'PaymentMethodsBanner';
exports.BANNER_BUNDLE_FILE_NAME = 'payment-methods-banner';
//# sourceMappingURL=config.js.map